import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MultimediaManagerDialogItemTypes } from '../../multimedia-manager-dialog/multimedia-manager-dialog-item.model';

@Component({
  selector: 'app-multimedia-manager-dialog-webscript',
  templateUrl: './multimedia-manager-dialog-webscript.component.html',
  styleUrls: ['./multimedia-manager-dialog-webscript.component.scss']
})
export class MultimediaManagerDialogWebscriptComponent implements OnInit {

  webtext: string;

  constructor(private dialogRef: MatDialogRef<MultimediaManagerDialogWebscriptComponent>) { }

  ngOnInit() { }

  public upload() {
    if (this.webtext) {
      this.dialogRef.close({ url: this.webtext, type: MultimediaManagerDialogItemTypes.WEB_SCRIPT });
    }
  }

}
